module.exports = "<section class=\"support-page\">\n  <app-contact></app-contact>\n</section>"